import {IStorageService} from "./CoreExportedFiles";

export class LocalStorageService implements IStorageService {
    save(key: string, jsonData: string, expirationMin: number): boolean {
        if (!this.isLocalStorageSupported()) { return false; }
        if (!expirationMin) {
            expirationMin = 5000;
        }
        var expirationMS = expirationMin * 60 * 1000;
        var record = { value: JSON.stringify(jsonData), timestamp: new Date().getTime() + expirationMS };
        try {
            localStorage.setItem(key, JSON.stringify(record));
        } catch (error) { return false;}
        return true;
    }

    get(key: string): any {
        if (!this.isLocalStorageSupported()) { return false; }
        var record = JSON.parse(localStorage.getItem(key) as string);
        if (!record) { return false; }
        if (new Date().getTime() >= record.timestamp) {
            localStorage.removeItem(key);
            return false;
        }
        else {
            return JSON.parse(record.value);
        }
    }

    isLocalStorageSupported() {
        /*
        if(Modernizr.localstorage) // Modernizr might not exists - CHO
            return true;
        */
        try {
            localStorage.setItem('test', '1');
            localStorage.removeItem('test');
            return true;
        }
        catch (error) {
            return false;
        }
    }

    clear() : void{
        localStorage.clear();
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }
}